export const surveyStatus = {
  EVALUATED: 'EVALUATED',
  RE_EVALUATED: 'RE-EVALUATED'
};
